module.exports = __webpack_public_path__ + "static/media/ic_reset_payment_due_date.ea06e2ac.svg";